module.exports = __webpack_public_path__ + "static/mock.0253eb67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/studysmart/mock.png
// module id = 1185
// module chunks = 35783957827783